import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companies: [],
  catalog: [],
  companyUsers: [],
  user: null,
  commodities: [],
  tests: [],
};

const bookTestSlice = createSlice({
  name: "bookTest",
  initialState,
  reducers: {
    fetchCompanies(state, action) {
      state.loading = true;
    },
    fetchCompaniesSuccess(state, action) {
      state.companies = action.payload.data.document;
      state.loading = false;
    },
    fetchCompaniesFailure(state, action) {
      state.loading = false;
    },
    fetchCatalog(state, action) {
      state.loading = true;
    },
    fetchCatalogSuccess(state, action) {
      state.catalog = action.payload.data.document;
      state.loading = false;
    },
    fetchCatalogFailure(state, action) {
      state.loading = false;
    },
    createOrder(state, action) {
      state.loading = true;
    },
    createOrderSuccess(state, action) {
      state.loading = false;
    },
    createOrderFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchCompanyUsers(state, action) {
      state.loading = true;
    },
    fetchCompanyUsersSuccess(state, action) {
      state.companyUsers = action.payload.data.document;
      state.loading = false;
    },
    fetchCompanyUsersFailure(state, action) {
      state.loading = false;
    },
    fetchUser(state, action) {
      state.loading = true;
    },
    fetchUserSuccess(state, action) {
      state.user = action.payload.data.document;
      state.loading = false;
    },
    fetchUserFailure(state, action) {
      state.loading = false;
    },
    fetchCommodities(state, action) {
      state.loading = true;
    },
    fetchCommoditiesSuccess(state, action) {
      state.loading = false;
      state.commodities = action.payload.data.document;
    },
    fetchCommoditiesFailure(state, action) {
      state.loading = false;
    },
    fetchTests(state, action) {
      state.loading = true;
    },
    fetchTestsSuccess(state, action) {
      state.loading = false;
      state.tests = action.payload.data.document;
    },
    fetchTestsFailure(state, action) {
      state.loading = false;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.companies = [];
      state.catalog = [];
      state.companyUsers = [];
      state.user = null;
      state.commodities = [];
      state.tests = [];
    },
  },
});

export const { actions, reducer, name: sliceKey } = bookTestSlice;
